module.exports = __webpack_public_path__ + "img/ics_o_arrow_right.062d6224.svg";